<template>
    <a-tabs v-model="selectedKey">
      <a-tab-pane key="1" tab="基本信息">
        <form
          :form="form"
          @submit="handleSubmit"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          :colon="false"
        >
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
                <InputField required labelWidth="35%" style="margin: 0.5rem 0.5rem;width:90%;" label="登录账号" type="text" id="code"
                            :modelValue="detail.code" placeholder="请输入登录账号"
                            @update:modelValue="(value) => handleModelValueUpdate('code', value)"/>
            </a-col>

            <a-col :lg="12" :md="12" :sm="24">
                <InputField required labelWidth="20%" style="margin: 0.5rem 0.5rem;width:90%;padding-left: 1rem;" label="姓名" type="text" id="name"
                            :modelValue="detail.name" placeholder="请输入姓名"
                            @update:modelValue="(value) => handleModelValueUpdate('name', value)"/>
            </a-col>

            <a-col :lg="12" :md="12" :sm="24">
                <InputField required labelWidth="35%" style="margin: 0.5rem 0.5rem;width:90%;" label="手机号码" type="text" id="mobile"
                            :modelValue="detail.mobile" placeholder="请输入手机号码"
                            @update:modelValue="(value) => handleModelValueUpdate('mobile', value)"/>
            </a-col>

            <a-col :lg="12" :md="12" :sm="24">
                <SelectField label="性别" labelWidth="20%" id="sex" style="margin: 0.5rem 0.5rem;width:90%;padding-left: 1rem;"
                             :modelValue="detail.sex" :options="genderList"
                             @update:modelValue="(value) => handleModelValueUpdate('sex', value)"/>
            </a-col>

            <a-col :lg="12" :md="12" :sm="24">
                <SelectField label="用户状态" labelWidth="35%" id="status" style="margin: 0.5rem 0.5rem;width:90%;"
                             :modelValue="detail.status" :options="statusList"
                             @update:modelValue="(value) => handleModelValueUpdate('status', value)"/>
            </a-col>
          </a-row>
          <div class="right">
            <a-space>
                <ButtonField text="关闭" @click="cancel" secondary />
                <ButtonField text="下一步" primary @click="handleSubmit"/>
            </a-space>
          </div>
        </form>
      </a-tab-pane>
      <a-tab-pane key="2" tab="分配角色">
          <Tablelist :showCheckbox="false" :list="roleList" :columns="tableColumns"/>
        <div class="center" style="margin-top: 16px">
          <a-space>
              <ButtonField text="关闭" @click="cancel" secondary />
              <ButtonField text="保存" primary @click="save"/>
          </a-space>
        </div>
      </a-tab-pane>
    </a-tabs>
</template>

<script>
import { edit, fetchDetail } from "@/api/setting/user";
import { fetchList as fetchRoleList } from "@/api/setting/role";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible:true,
      selectedKey: "1",
      form:{
          code:null,
          name:null,
          mobile:null,
          sex:null,
          status:null,
      },
      roleList: [],
      selectedRoleKeys: [],
      detail: {},
      tableColumns: [
          {
              key: 'code',
              title: '登录账号',
              field: 'code',
              infotype: 'text'
          },
          {
              key: 'name',
              title: '姓名',
              field: 'name',
              infotype: 'text'
          },
          {
              key: 'sex',
              title: '性别',
              field: 'sex',
              infotype: 'template',
          },
          {
              key: 'mobile',
              title: '手机号',
              field: 'mobile',
              infotype: 'text',
          },
          {
              key: 'role',
              title: '角色',
              field: 'role',
              infotype: 'template'
          },
          {
              key: 'status',
              title: '状态',
              field: 'status',
              infotype: 'template',
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template'
          }
      ],
    };
  },
   props:{
      id:{
          type: String,
          default: ''
      }
  },
  mounted() {
    const id = this.$props.id;
    console.log("id::::",id)
    fetchDetail({
      id,
    }).then((res) => {
      this.detail = res ?? {};
      if (Array.isArray(res?.roles)) {
        this.selectedRoleKeys = res.roles.map((item) => item.id);
      }
    });

    fetchRoleList({
      pageNum: 1,
      pageSize: 1000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.roleList = Object.freeze(res.list);
      }
    });
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    genderList() {
      return this.findDataDict("gender");
    },
    statusList() {
      return this.findDataDict("status");
    },
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    handleSubmit() {
       this.selectedKey = "2";
    },

    onSelectRoleChange(keys) {
      this.selectedRoleKeys = keys;
    },

    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...this.detail,
            ...values,
            roles: this.selectedRoleKeys,
            // password: encrypt.encrypt("123456"),
          };

          edit(params).then(() => {
            this.cancel();
          });
        } else {
          this.$message.error("请填写用户基本信息");
          return;
        }
      });
    },

    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .ant-tabs-nav .ant-tabs-tab-active{
  color: #00fd95;
  text-shadow: 0 0 0.25px #00fd95;
}
::v-deep .ant-tabs-ink-bar{
  background: #00ff96;
}
::v-deep .ant-tabs-tab{
  color:#fff;
}
</style>
